document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll("[data-faq-item]");

  faqItems.forEach((item) => {
    const trigger = item.querySelector("[data-faq-trigger]");
    const answer = item.querySelector("[data-faq-answer]");

    trigger.addEventListener("click", function () {
      const isActive = item.classList.contains("active");

      // Usuń klasę 'active' ze wszystkich elementów i zresetuj wysokości
      faqItems.forEach((i) => {
        i.classList.remove("active");
        const answer = i.querySelector("[data-faq-answer]");
        answer.style.height = "0px";
      });

      if (!isActive) {
        // Dodaj klasę 'active' do aktualnie klikniętego elementu
        item.classList.add("active");

        // Ustaw wysokość elementu 'answer' na jego pełną wysokość
        const fullHeight = answer.scrollHeight + "px";
        answer.style.height = fullHeight;
      }
    });
  });
});
